import { injectable } from "inversify";
import { action, makeObservable, observable } from "mobx";
import IdentityObject from "@/src/domain/common/identity-object";

@injectable()
export default class AppState extends IdentityObject {
  constructor() {
    super();
    this.isLoading = true;
    makeObservable(this, {
      isLoading: observable,
      setLoading: action,
    });
  }

  isLoading: boolean;

  setLoading(loading: boolean) {
    this.isLoading = loading;
  }
}
